import { BaseLayer } from "../BaseLayer";
export class MapTilerBaseLayer extends BaseLayer {
    constructor(url) {
        super(url);
    }
    getLayerType(layer) {
        if (layer && layer["source-layer"] === "transportation") {
            return "road";
        }
        if (layer && layer["source-layer"] === "transportation_name") {
            return "label";
        }
        if (layer && layer.type == "symbol" && layer.id !== "housenumber") {
            return "symbol";
        }
        if (layer.id == "background") {
            return "background";
        }
        return undefined;
    }
    customizeWithSource(style, roadSourceId) {
        // replace all the transportation layer sources.
        // TODO: remove the need to customize the oneways.
        // customize oneway layers, they are slightly different in the impact API.
        for (let l = 0; l < style.layers.length; l++) {
            const layer = style.layers[l];
            if (layer) {
                const sourceLayer = layer["source-layer"];
                if (sourceLayer === "transportation") {
                    if (layer.id.includes("rail")) {
                        continue;
                    }
                    const layerWithSource = layer;
                    if (typeof layerWithSource?.source === "undefined")
                        continue;
                    layerWithSource.source = roadSourceId;
                }
            }
        }
        return style;
    }
}
